import { Component, OnInit } from '@angular/core';
import{ FormBuilder, FormGroup, Validators, AbstractControl } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from '../../../services/common.service';
import { ApiService } from '../../../services/api.service';
import { Location } from '@angular/common';
import { TranslationService } from 'src/app/services/translation.service';


@Component({
  selector: 'app-systemtranslation',
  templateUrl: './systemtranslation.page.html',
  styleUrls: ['./systemtranslation.page.scss'],
})
export class SystemtranslationPage implements OnInit {


  systemtranslationForm:FormGroup;
  submitted = false;
  SystemTranslationId: string;

  systemtranslation: any = {};
  systemtranslations: any = {};
  tempSystemTranslations: any = {}
  data: any = {};

  showPage: boolean = false;

  breadcrumb: any = {
    TranslationText: null
  }

  locale: any;
  tempLocale: any;

  constructor(private router: Router, private route: ActivatedRoute, private formBuilder: FormBuilder, private _apiService: ApiService, public _commonService: CommonService, private location: Location, private _translationService: TranslationService) { }

  ngOnInit() {
    this.systemtranslationForm= this.formBuilder.group({
      SystemTranslationCode: ['', Validators.required],
      Text:['', Validators.required]
      });
  }

  ionViewDidEnter() {
    this.SystemTranslationId = this.route.snapshot.paramMap.get('id');
    this.locale = Number((localStorage.locale && localStorage.locale != '') ? localStorage.locale : 1043);
    this.tempLocale = this.locale;
     if (this.SystemTranslationId== '0') {
      this.SystemTranslationId = null;
      }
     if (this.SystemTranslationId) {
      this.getSystemTranslationDetails();
      //  this.systemtranslationForm.get('SystemTranslationCode').disable({ onlySelf: true });
      }else{
       this.getLocales();
       this.showPage = true;
       this.systemtranslations =
         {
           SystemTranslationCode: this.SystemTranslationId,
           Translations: [
             {
               Text: "",
               LocaleId: this.locale,
             }
           ]
         }
      }
    }

  async getLocales() {
    try {
      if (localStorage.domainLocales) {
        this.systemtranslation.AllLocales = JSON.parse(localStorage.domainLocales);
        for (let i = 0; i < this.systemtranslation.AllLocales.length; i++) {
          if (this.systemtranslation.AllLocales[i].LocaleIconUrl == 'flag-icon-nl') {
            this.systemtranslation.AllLocales[i].Icon = 'assets/flags/1x1/nl.svg'
          }
          if (this.systemtranslation.AllLocales[i].LocaleIconUrl == 'flag-icon-gb') {
            this.systemtranslation.AllLocales[i].Icon = 'assets/flags/1x1/gb.svg'
          }
        }
      }else{
        let localeData = await this._apiService.getDomainLocales('', 1, 0);
        this.systemtranslation.AllLocales = localeData.body;
        localStorage.domainLocales = JSON.stringify(localeData.body);
        for (let i = 0; i < this.systemtranslation.AllLocales.length; i++) {
          if (this.systemtranslation.AllLocales[i].LocaleIconUrl == 'flag-icon-nl') {
            this.systemtranslation.AllLocales[i].Icon = 'assets/flags/1x1/nl.svg'
          }
          if (this.systemtranslation.AllLocales[i].LocaleIconUrl == 'flag-icon-gb') {
            this.systemtranslation.AllLocales[i].Icon = 'assets/flags/1x1/gb.svg'
          }
        }
      }
    } catch (error) {
      this._commonService.log(error, this._commonService.ERROR);
    }
  }

    async getSystemTranslationDetails() {
      try {
        this._commonService.presentLoading();
        let res = await this._apiService.getSystemTranslation(this.SystemTranslationId);
        this.systemtranslations = res.body;
        this.tempSystemTranslations = res.body
        await this.getLocales();
        this._commonService.log(this.systemtranslations, this._commonService.LOG);

        let translation = this.systemtranslations.Translations.find(x => x.LocaleId == this.locale);
        this.breadcrumb.TranslationText = this.systemtranslations.SystemTranslationCode;
        if (translation) {
          this.systemtranslationForm.patchValue({
            Text: translation.Text,
            SystemTranslationCode: this.systemtranslations.SystemTranslationCode
          });
        }
        else {
          this.systemtranslations.Translations.push({
            Text: "",
            LocaleId: this.locale,
          });
          this.systemtranslationForm.patchValue({
            Text: "",
            SystemTranslationCode: this.systemtranslations.SystemTranslationCode
          });
        }
        this._commonService.dismiss();
        this.systemtranslationForm.updateValueAndValidity();
        this.showPage = true;
      } catch (error) {
        this._commonService.dismiss();
        this._commonService.log(error, this._commonService.ERROR);
      }
    }
    
    get f() { return this.systemtranslationForm.controls; }
     
    async onSubmit() {
      this.submitted = true;
      if (this.systemtranslationForm.invalid) {
        this._commonService.scrollToError();
        return;
      }
      this._commonService.presentLoading();
        try {
          // this.AllLocales.forEach( locale => {
          //   let translationExists = this.systemtranslations.Translations.find(x => x.LocaleId == locale.id);
          //   if (!translationExists) {
          //     this.systemtranslations.Translations.push({
          //       Text: this.systemtranslationForm.value.Text,
          //       LocaleId: locale.id,
          //     });
          //   } else if (translationExists.Text == ''){
          //     translationExists.Text = this.systemtranslationForm.value.Text
          //   }
          // });
          let translation = this.systemtranslations.Translations.find(x => x.LocaleId == this.locale);
          translation.Text = this.systemtranslationForm.value.Text;
          this.systemtranslations.SystemTranslationCode = this.systemtranslationForm.value.SystemTranslationCode.replace(/\s+/g, '');
          this.systemtranslations.SystemTranslationId = this.SystemTranslationId;
          let res = await this._apiService.postSystemTranslation(this.systemtranslations);
          if(res.translationCode){
            this.SystemTranslationId = res.translationCode;
            this.location.replaceState('maintenance/systemtranslations/' + this.SystemTranslationId);
          }
          this._commonService.log(this.systemtranslations, this._commonService.LOG);
          this._commonService.dismiss();
          this._commonService.showToast(this._commonService.getLocalTranslation('label-recordSaved'));

          // get system translations
          this._translationService.getTranslation(this.locale);

         // this.router.navigate(['/maintenance/systemtranslations']);
       }
       catch (error) {
        if(error.status >= 500 && error.status < 600){
          let translation = this.tempSystemTranslations.Translations.find(x => x.LocaleId == this.locale);
        this.breadcrumb.TranslationText = this.tempSystemTranslations.SystemTranslationCode;
        if (translation) {
          this.systemtranslationForm.patchValue({
            Text: translation.Text,
            SystemTranslationCode: this.tempSystemTranslations.SystemTranslationCode
          });
        }
        else {
          this.tempSystemTranslations.Translations.push({
            Text: "",
            LocaleId: this.locale,
          });
          this.systemtranslationForm.patchValue({
            Text: "",
            SystemTranslationCode: this.tempSystemTranslations.SystemTranslationCode
          });
        }
          
        }
        this._commonService.dismiss();
        this._commonService.log(error, this._commonService.ERROR);
       }
     }

    delete() {
    this._commonService.presentAlertConfirm()
      .then(async (res) => {
        try {
          this._commonService.presentLoading();
          await this._apiService.deleteSystemTranslation(this.SystemTranslationId);
          this._commonService.dismiss();
          this._commonService.log(res, this._commonService.LOG);
          this.goBack();
          }  catch (error) {
          this._commonService.dismiss();
          this._commonService.log(error, this._commonService.ERROR);
          }
      })
      .catch((err) => {
        this._commonService.log(err, this._commonService.LOG);
        })
    }
     
     goBack() {
      this.location.back();
    }

  changeLocale() {
    if (this.SystemTranslationId && this.systemtranslations.Translations) {
      let tempTranslation = this.systemtranslations.Translations.find(x => x.LocaleId == this.tempLocale);
      tempTranslation.Text = this.systemtranslationForm.value.Text;
      let translation = this.systemtranslations.Translations.find(x => x.LocaleId == this.locale);
      if (translation){
        this.systemtranslationForm.patchValue({
          Text: translation.Text,
        });
      }
      else{
        this.systemtranslations.Translations.push({
          Text: "",
          LocaleId: this.locale,
        });
        this.systemtranslationForm.controls['Text'].reset();
      }
      this.tempLocale = this.locale;
    } else {
      let tempTranslation = this.systemtranslations.Translations.find(x => x.LocaleId == this.tempLocale);
      if (tempTranslation) {
        tempTranslation.Text = this.systemtranslationForm.value.Text;
        this.tempLocale = this.locale;

        let schedule = this.systemtranslations.Translations.find(x => x.LocaleId == this.locale);
        if (schedule) {
          this.systemtranslationForm.patchValue({
            Text: schedule.Text,
          });
        }
        else {
          this.systemtranslations.Translations.push({
            Text: "",
            LocaleId: this.locale,
          });
          this.systemtranslationForm.controls['Text'].reset();
          this.tempLocale = this.locale;
        }
      }
    }
  }

  onBlur(){
    console.log(this.systemtranslationForm)
  }

  onActionChange(obj) {

    switch (obj.Action) {
      case "save":
          this.onSubmit();
          break;
      case "delete":
          this.delete();
          break;
      case "backToList":
          this.goBack();
          break;
      case "backToMain":
          this.router.navigate(['maintenance'], { replaceUrl: true })
          break;
      case "back":
          this.goBack();
          break;
      }
      
  }

}
